import http from "@/settings/apiSettings";

/**
 * O notificare in-app, așa cum vine de la backend (Comercial / api/notificari).
 * Convenția JSON e PreserveCaseNamingPolicy, deci proprietățile păstrează PascalCase.
 */
export interface Notificare {
  ID: string;
  Titlu: string;
  Mesaj: string;
  Icon?: string | null;
  Severitate?: string | null;
  Modul?: string | null;
  EntitateTip?: string | null;
  EntitateID?: string | null;
  Ruta?: string | null;
  RutaParams?: string | null;
  Citita: boolean;
  DataCitire?: string | null;
  Sursa?: string | null;
  DataCreare: string;
}

export interface NotificariResponse {
  NrNecitite: number;
  Notificari: Notificare[];
}

/**
 * Client pentru inbox-ul de notificări. API-ul e găzduit în modulul Comercial (port 817),
 * mereu pornit, ca să fie disponibil din orice modul (clopoțelul e global în shell).
 */
class NotificariService {
  get(): Promise<{ data: NotificariResponse }> {
    return http.clientComercial.get("/notificari");
  }
  marcheazaCitit(id: string): Promise<any> {
    return http.clientComercial.post(`/notificari/${id}/citit`);
  }
  citesteTot(): Promise<any> {
    return http.clientComercial.post("/notificari/citeste-tot");
  }
  sterge(id: string): Promise<any> {
    return http.clientComercial.delete(`/notificari/${id}`);
  }
}

export default new NotificariService();
